"use client";

import * as React from "react";
import styled from "styled-components";

import { ILanguageSelectorProps } from "./common";
import { HoverItem } from "./HoverItem";
import { LanguageSelectorDropdown } from "./LanguageSelectorDropdown";
import { LanguageSelectorText } from "./LanguageSelectorText";

/**
 * @trackcomponent
 * @link [Docs](https://slate.faire.team/component/language-selector)
 */
export const LanguageSelector = (props: ILanguageSelectorProps) => (
  <LanguageSelectorWrapper
    hoverChild={<LanguageSelectorDropdown {...props} />}
    position={props.position === "up" ? "top" : "bottom"}
    data-test-id="languageDropdown"
  >
    <LanguageSelectorText {...props} />
  </LanguageSelectorWrapper>
);

const LanguageSelectorWrapper = styled(HoverItem)`
  position: relative;
  width: min-content;
`;
